module.exports = __webpack_public_path__ + "img/vps_ip.2ba37f5.png";